import React from 'react';
import LazyImage from '../../components/LazyImage';

interface ContactUsProps {
  onJoinCommunity?: () => void;
}

const ContactUs: React.FC<ContactUsProps> = ({ onJoinCommunity }) => {

  return (
    <section className="relative h-[65vh] flex items-center">
      {/* Background Image */}
      <LazyImage 
        src="/images/ContactUs.webp" 
        alt="Mining site background" 
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Dark Overlay */}
      <div 
        className="absolute inset-0 z-10" 
        style={{ backgroundColor: 'rgba(26, 42, 68, 0.75)' }}
      />
      
      {/* Content Overlay */}
      <div className="relative z-10 mx-auto px-4 md:px-10 lg:px-32 w-full">
        <div className="w-full text-center">
          {/* Main Headline */}
          <h1 className="text-[#FFFFFF] text-[30px] md:text-[40px] lg:text-[60px] font-[400] leading-[45px] md:leading-[52px] lg:leading-[65px] mb-10 md:mb-8">
            <span className="font-bold">Contact Us</span>
          </h1>
       
          {/* Body Text */}
          <p className="text-[#FFFFFF] text-[16px] md:text-[20px] lg:text-[26px] font-[600] leading-[24px] md:leading-[30px] lg:leading-[40px] mb-10 md:mb-12 lg:w-2/3 text-center mx-auto">
          Get in touch with us today to learn how we can support your business with tailored wholesale solutions and exceptional service
          </p>
           </div>
      </div>
    </section>
  );
};

export default ContactUs;
